<template>
  <div>
    <md-button
      :type="type"
      round
      :plain="plain"
      :icon="loading? 'spinner' : ''"
      :icon-svg="true"
      :inactive="loading || disabled"
      @click="$emit('click')"
    >
      <slot></slot>
    </md-button>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'

export default {
  name: 'ButtonPrimary',
  components: {
    [Button.name]: Button,
  },
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    plain: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="stylus">

</style>
